import React, { createContext, useContext, useState, type ReactNode } from "react";
import ReactDOM from "react-dom";
import Flex from "./Flex";
import "./ModalContext.css";

interface ModalContextType {
  showModal: (content: ReactNode, title?: ReactNode, modalStyle?: React.CSSProperties) => void;
  hideModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const useModal = () => {
  const ctx = useContext(ModalContext);
  if (!ctx) throw new Error("useModal must be used within ModalProvider");
  return ctx;
};

const defaultModalStyle: React.CSSProperties = {
  width: '600px',
  maxWidth: '80%',
  maxHeight: '80%',
  overflowY: 'auto',
};
export const ModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [modalContent, setModalContent] = useState<ReactNode>(null);
  const [modalTitle, setModalTitle] = useState<ReactNode>(null);
  const [modalStyle, setModalStyle] = useState<React.CSSProperties>(defaultModalStyle);

  const showModal = (content: ReactNode, title?: ReactNode, modalStyle?: React.CSSProperties) => {
    setModalContent(content);
    setModalTitle(title || null);
    setModalStyle(modalStyle || defaultModalStyle);
  };
  
  const hideModal = () => {
    setModalContent(null);
    setModalTitle(null);
  };

  return (
    <ModalContext.Provider value={{ showModal, hideModal }}>
      {children}
      {modalContent &&
        ReactDOM.createPortal(
          <div className="modal-overlay">
            <div className="modal-body" style={modalStyle}>
                <Flex className="header bg-primary color-white">
                    <div className="title">{modalTitle}</div>
                    <button className="close-button" onClick={hideModal}>
                        <span className="icon">×</span>
                    </button>
                </Flex>
                <div className="content position-relative h-100">
                    {modalContent}
                </div>
            </div>
          </div>,
          document.body
        )}
    </ModalContext.Provider>
  );
};
